module.exports = __webpack_public_path__ + "static/media/timelapse.39613623.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/Drone/timelapse.mp4
// module id = 321
// module chunks = 0